export default __webpack_public_path__ + "static/media/level_3.ace25afa.jpg";